import { render, staticRenderFns } from "./FishcarReports _v1.vue?vue&type=template&id=540484d0"
import script from "./FishcarReports _v1.vue?vue&type=script&lang=js"
export * from "./FishcarReports _v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports